export const navItems = [
  { id: 'slide-home', label: 'Home' },
  { id: 'slide-care', label: 'Care' },
  { id: 'slide-consult', label: 'Consult' },
  { id: 'slide-connect', label: 'Connect' },
  { id: 'slide-courses', label: 'Modules' }
];

export const eventData = [
  {
    type: 'Workshop',
    title: 'Faculty Development Workshop: Robotics Essentials',
    description:
      'A 3-Hour immersive workshop introducing robotics concepts using virtual simulation platforms,Explore robot kinematics, sensing, control, and autonomous systems to integrate robotics into academic programs. ',
    dates: 'July 20 &21, 2026',
    venue: 'University of Buraimi, Oman',
    mode: 'Online',
  },
  {
    type: 'Course',
    title: 'Fundamentals of Robotics & AI',
    description:
      'A comprehensive curriculum-aligned course covering robotic hardware, AI fundamentals, and simulation-driven automation,Designed to complement the academic syllabus with hands-on learning and industry-relevant concepts.',
    dates: 'Aug-Sep, 2026',
    venue: 'MIT, MAHE – Yelahanka Campus',
    mode: 'On-site',
  },
 
  {
    type: 'Workshop',
    title: 'Robotics Foundations: Empowering Women in Technology',
    description:
      'A beginner-friendly 3-hour workshop designed to introduce robotics through virtual simulation.Gain practical insights into robot operation, autonomous systems, and emerging career opportunities in robotics.',
    dates: 'July  24 2026',
    venue: 'Christ University, Bangalore',
    mode: 'On-site',
  },
  
];

export const modelData = [
  {
    tag: 'ENABLE',
    title: 'Model A - Operate & Train',
    description: 'For organisations with an existing lab or equipment.',
    features: [
      'Operational readiness of your robotics infrastructure',
      'Training for students, faculty and internal teams',
      'Standardised workflows and operating procedures'
    ],
    outcome: 'A functional and actively used lab with trained users.'
  },
  {
    tag: 'ENHANCEMENT UPGRADE',
    title: 'Model B - Upgrade & Deploy',
    description: 'For organisations with an existing lab or robot fleet that needs upgrading.',
    features: [
      'Selection of new robot platforms and tools',
      'Integration and deployment support',
      'Structured training pathways for new technologies'
    ],
    outcome: 'An upgraded model with applied robotics and AI use-cases.',
    highlight: true
  },
  {
    tag: 'ECOSYSTEM',
    title: 'Model C - Build, Operate & Transfer',
    description: 'For organisations planning a new AI & Robotics Centre of Excellence.',
    features: [
      'Space planning and layout advisory',
      'Platform and vendor recommendations',
      'Deployment and hands-on training',
      'Proposal support for funding and strategic programs'
    ],
    outcome: 'A fully operational and sustainable AI & Robotics Centre.'
  }
];

export const courseData = [
  {
    image: '/images/courses_robotics_1774087355209.png',
    duration: '25-30 Hrs',
    title: 'Applied AI & Computer Vision',
    description: 'Building and deploying AI, CV, and NLP solutions with hardware-level integrations.'
  },
  {
    image: '/images/consult_lab_1774087300916.png',
    duration: '25-30 Hrs',
    title: 'ROS2 Fundamentals',
    description: 'Core introduction covering ROS2 structure, node programming, and simulation basics.'
  },
  {
    image: '/images/hero_robotics_1774087255432.png',
    duration: '30-36 Hrs',
    title: 'Fundamentals of Robotics & AI',
    description: 'Master the future of automation at the perfect intersection of robotics and AI.'
  },
  {
    image: '/images/care_training_1774087284054.png',
    duration: '25-30 Hrs',
    title: 'Drone Technology',
    description: 'Assembly, autonomous testing, calibration, and supervised pilot flight operations.'
  },
  {
    image: '/images/care_training_new_1774088234687.png',
    duration: '25-30 Hrs',
    title: 'Embedded Advance Wheeled Robots',
    description: 'Sensor integration, obstacle avoidance, and mapping/navigation for AMRs.'
  }
];